/**
 * 어드민 토큰 — localStorage에 보관. 사용자 web과는 별도 키 사용.
 */
const TOKEN_KEY = 'butler_admin_token';
const EMAIL_KEY = 'butler_admin_email';
const EXP_KEY = 'butler_admin_exp';

export interface AdminSession {
  token: string;
  email: string;
  expiresAt: Date;
}

export function getAdminSession(): AdminSession | null {
  const token = localStorage.getItem(TOKEN_KEY);
  const email = localStorage.getItem(EMAIL_KEY);
  const exp = localStorage.getItem(EXP_KEY);
  if (!token || !email || !exp) return null;
  const expDate = new Date(exp);
  if (Number.isNaN(expDate.getTime()) || expDate.getTime() <= Date.now()) {
    clearAdminSession();
    return null;
  }
  return { token, email, expiresAt: expDate };
}

export function setAdminSession(s: AdminSession): void {
  localStorage.setItem(TOKEN_KEY, s.token);
  localStorage.setItem(EMAIL_KEY, s.email);
  localStorage.setItem(EXP_KEY, s.expiresAt.toISOString());
}

export function clearAdminSession(): void {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(EMAIL_KEY);
  localStorage.removeItem(EXP_KEY);
}
